import React from 'react';
//material
import {Card, CardContent, withStyles, Grid, IconButton} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
import { Facebook, LinkedIn, Language, Twitter } from '@material-ui/icons';
//styles
import styles from './contact-details-card-styles';

const ContactDetailsCardView = (props) => {
  const {classes, isLoading, member} = props;
  return (
    <Card>
      <CardContent className={classes.cardContent}>
        {
          isLoading ?
            <Skeleton height={40} width={'60%'} /> :
            <div className={classes.title}>
              Contact Details
            </div>
        }

        <Grid container>
          <Grid item xs={12} md={8}>
            {
              !isLoading ?
              <table className={classes.table}>
                <tbody>
                <tr>
                  <td className={classes.column}>Email Address</td>
                  <td className={classes.data}>{member.emailAddress ? <a href={'mailto:' + member.emailAddress}>{member.emailAddress}</a> : '-'}</td>
                </tr>
                <tr>
                  <td className={classes.column}>Phone Number</td>
                  <td className={classes.data}>{member.phoneNumber ? <a href={'tel:' + member.phoneNumber}>{member.phoneNumber}</a> : '-'}</td>
                </tr>
                </tbody>
              </table> :
              <>
                <Skeleton height={23} className={classes.skeletonRow}/>
                <Skeleton height={23} className={classes.skeletonRow}/>
              </>
            }
          </Grid>
          <Grid item xs={12} md={4} className={classes.socialIconContainer}>
            {
              isLoading ?
              <Skeleton variant={'circle'} height={40} width={40} className={classes.skeletonIconButton}/> :
              <IconButton
                classes={{ root: classes.facebookButton + ' ' + classes.iconButton }}
                disabled={!member.facebookProfileUrl}
                href={member.facebookProfileUrl}
                target={'_blank'}
                rel={'noopener'}>
                <Facebook className={classes.icon}/>
              </IconButton>
            }

            {
              isLoading ?
                <Skeleton variant={'circle'} height={40} width={40} className={classes.skeletonIconButton}/> :
                <IconButton
                  classes={{ root: classes.linkedInButton + ' ' + classes.iconButton }}
                  disabled={!member.linkedInProfileUrl}
                  href={member.linkedInProfileUrl}
                  target={'_blank'}
                  rel={'noopener'}>
                  <LinkedIn className={classes.icon}/>
                </IconButton>
            }

            {
              isLoading ?
                <Skeleton variant={'circle'} height={40} width={40} className={classes.skeletonIconButton}/> :
                <IconButton
                  classes={{ root: classes.twitterButton + ' ' + classes.iconButton }}
                  disabled={!member.twitterProfileUrl}
                  href={member.twitterProfileUrl}
                  target={'_blank'}
                  rel={'noopener'}>
                  <Twitter className={classes.icon}/>
                </IconButton>
            }

          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (ContactDetailsCardView);
